import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const ebookBenefits = ['Cómo el apego afecta tu mente y tus emociones', 'Por qué pierdes energía pensando demasiado en alguien', 'Cómo recuperar claridad emocional', 'Qué hacer para empezar a reconstruirte emocionalmente', 'Cómo volver a conectar contigo y con tu propósito'];
export function EbookSection() {
  return <section className="py-24 bg-teal-950 px-6" data-id="element-50">
      <div className="max-w-6xl mx-auto" data-id="element-51">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-52">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1 flex justify-center" data-id="element-53">
            {/* Book Cover Image — blends seamlessly into the dark background */}
            <img src="https://cdn.magicpatterns.com/uploads/59wxMe5mu5YFA7Mr9nBQVc/Portada_FODA_Freddy_Pimentel_Listo.png" alt="Portada del libro Método F.O.D.A — Recupera tu Soberanía Emocional, por Freddy Pimentel" style={{
            mixBlendMode: 'lighten'
          }} className="relative w-full max-w-md scale-110 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-54" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-55">
            <h2 className="text-3xl md:text-4xl lg:text-5xl mb-4 text-cream" data-id="element-56">
              Y además recibirás{' '}
              <span className="italic text-terracotta" data-id="element-57">GRATIS</span> el Ebook:
            </h2>
            <h3 className="text-2xl font-serif text-cream mb-8" data-id="element-58">
              MÉTODO F.O.D.A
            </h3>

            <p className="text-lg text-cream/80 mb-8 flex items-center gap-3" data-id="element-59">
              <span className="text-2xl" data-id="element-60">📘</span> Una guía emocional donde
              descubrirás:
            </p>

            <div className="space-y-4" data-id="element-61">
              {ebookBenefits.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-62">
                  <div className="mt-1 w-5 h-5 rounded-full bg-terracotta/20 flex items-center justify-center flex-shrink-0" data-id="element-63">
                    <Check className="w-3 h-3 text-terracotta" data-id="element-64" />
                  </div>
                  <p className="text-cream/90" data-id="element-65">{item}</p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}